'use client';

import React from 'react';
import { generateSlug } from '@/lib/slugify';

export default function TeacherCoursesOffered({ profileData }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-2xl font-bold text-gray-900">Classes Offered</h2>
      </div>

      <div className="px-6 py-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {profileData?.teacherCourses?.map((course) => (
            <a
              key={course.id}
              href={`/classes/${generateSlug(course.name, course.id)}`}
              className="group cursor-pointer border border-gray-200 rounded-lg overflow-hidden hover:border-blue-300 hover:shadow-lg transition-all block"
            >
              <img
                src={course.imageUrl || '/placeholder.svg'}
                alt={course.name}
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform"
              />

              <div className="p-4">
                <h3 className="font-semibold text-gray-900 mb-2">
                  {course.name}
                </h3>

                <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                  {course.description}
                </p>
                                
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4 text-sm text-gray-600">
                    <span>Per Class:</span>
                    <div className="flex items-center gap-1">
                      <svg
                        className="h-4 w-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                        />
                      </svg>
                      {course.perClassPrice}
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}